export const appRegistration = async (data) => {
  try {
    const response = await fetch(import.meta.env.VITE_APP_REG_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    const responseText = await response.text();

    if (!response.ok) {
      // Пробуем извлечь красивое сообщение об ошибке
      let errorData;
      try {
        errorData = JSON.parse(responseText);
        const errorMessage = errorData?.error_message?.[0]?.[1] || 'Unknown error';
        return { data: null, error: errorMessage };
      } catch {
        return { data: null, error: responseText };
      }
    }
    const result = JSON.parse(responseText);
    return { data: result, error: null };

  } catch (error) {
    return { data: null, error: error.message || 'Request failed' };
  }
};
